export const Email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const avoidNumber = /^\D*$/;
export const avoidSpecialChracters = /^[a-zA-Z\s]+$/;

export const BASE_IMAGE_URL =
  "https://tharra-website-assets.s3.amazonaws.com/assets/images";

export const BASE_VIDEO_URL =
  "https://tharra-website-assets.s3.amazonaws.com/assets/video";
